about works!
<iframe
  src="https://yandex.ru/map-widget/v1/?z=12&ol=biz&oid=215189231447"
  width="560"
  height="400"
  frameborder="0"
></iframe>
